import { LANGS, useI18n } from "@/lib/i18n";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang } = useI18n();
  const current = LANGS.find(l => l.code === lang) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="border-zinc-700 hover:bg-zinc-900 hover:text-white rounded-sm gap-2"
          data-testid="language-switcher"
        >
          <Globe className="h-3.5 w-3.5" />
          <span>{current.flag}</span>
          <span className="hidden sm:inline">{current.label}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#121212] border-zinc-800 min-w-[180px]">
        {LANGS.map(l => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`lang-option-${l.code}`}
            className="cursor-pointer text-zinc-300 focus:bg-zinc-800 focus:text-white flex items-center gap-2"
          >
            <span className="text-base">{l.flag}</span>
            <span className="flex-1">{l.label}</span>
            {l.code === lang && <Check className="h-3.5 w-3.5 text-emerald-400" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
